import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ListItemIcon, Typography } from "@mui/material";
import React from "react";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";
import type { MeasureDescriptor, MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import CustomMeasureDialog from "../../customMeasure/CustomMeasureDialog.tsx";
import ExplainMeasureDialog from "../../customMeasure/ExplainMeasureDialog.tsx";

interface Props {
  measure: MeasureField;
  onClose: () => void;
}

export default function ExplainMenuItem(props: Props) {
  const { measure, onClose } = props;
  const [measureToEdit, setMeasureToEdit] = React.useState<MeasureDescriptor>();

  const [showExplain, setShowExplain] = React.useState(false);

  const doShowExplain = React.useCallback(() => {
    setShowExplain(true);
  }, []);

  return (
    <>
      <PopoverMenuItem onClick={doShowExplain} sx={{ px: 2, py: 0.75 }}>
        <ListItemIcon sx={{ color: "secondary.main" }}>
          <InfoOutlinedIcon />
        </ListItemIcon>
        <Typography>Measure details...</Typography>
      </PopoverMenuItem>
      {showExplain && (
        <ExplainMeasureDialog
          measure={measure.meta}
          onClose={() => {
            setShowExplain(false);
            onClose();
          }}
          onEdit={(measure) => {
            setShowExplain(false);
            setMeasureToEdit(measure);
          }}
        />
      )}
      {measureToEdit && (
        <CustomMeasureDialog
          measure={measureToEdit}
          defaultGroup={measureToEdit.group}
          onClose={() => setMeasureToEdit(undefined)}
        />
      )}
    </>
  );
}
